import React, { FC, useState } from 'react';
import { Box, Button, Container, Divider, Grid, Hidden, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { HistoryComponent } from 'components/structures/about-us';
import { CarouselArrowIconPos } from 'svgs';
import CircularLogo from './LogoBlock';
import LogoBlock from './LogoBlock';

interface CompanyHistoryProps {
  title: string;
  listItems: Array<{ paragraph1?: string; paragraph2?: string }>;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      padding: theme.spacing(20, 0, 15),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(20, 0),
      },
    },
    title: {
      color: theme.palette.primary.dark,
      fontWeight: 500,
    },
    text: {
      fontWeight: 400,
      marginBottom: theme.spacing(5),
      [theme.breakpoints.up('sm')]: {
        fontWeight: 500,
      },
    },
    divider: {
      backgroundColor: theme.palette.primary.main,
      maxWidth: 100,
    },
    button: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      fontWeight: 400,
      minWidth: 168,
      minHeight: 58,
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
      },
    },
    textBtn: {
      fontWeight: 500,
      color: theme.palette.common.white,
    },
    icon: {
      marginLeft: theme.spacing(2),
    },
    // imgBox: {
    //   marginBottom: theme.spacing(16.5),
    // },
  });
});

const CompanyHistory: FC<CompanyHistoryProps> = ({ title, listItems }) => {
  const classes = useStyles();
  const [showMore, setShowMore] = useState<boolean>(false);

  const onClickShowMore = () => {
    setShowMore(!showMore);
  };

  return (
    <Container fixed id={'our-history'}>
      <Grid container direction="row" justify="space-between" className={classes.root}>
        <Grid item sm={12} md={12} lg={6}>
          <Typography variant="h2" className={classes.title} data-aos="fade-up">
            {title}
          </Typography>
          <Box mt={5} mb={8}>
            <Divider className={classes.divider} />
          </Box>
          {listItems.map(({ paragraph1 }, index) => (
            <Typography color="textSecondary" className={classes.text} data-aos="fade-up" key={index}>
              {paragraph1}
            </Typography>
          ))}
          {showMore &&
            listItems.map(({ paragraph2 }, index) => (
              <Typography color="textSecondary" className={classes.text} key={index}>
                {paragraph2}
              </Typography>
            ))}
          <Button variant={'contained'} className={classes.button} onClick={onClickShowMore} data-aos="fade-up">
            <Typography variant="body1" className={classes.textBtn}>
              {!showMore ? 'Read more' : 'Read Less'}
            </Typography>
            <CarouselArrowIconPos position={showMore ? 'down' : 'up'} className={classes.icon} />
          </Button>
        </Grid>
          <Grid item xs={12} lg={5}>
            <LogoBlock />
          </Grid>
      </Grid>
    </Container>
  );
};

export default CompanyHistory;
